import "../../styles/custom-select.css";

function normalizeOption(option) {
  if (option === undefined || option === null) {
    return null;
  }

  if (typeof option === "object") {
    const normalizedValue =
      option.value ?? option.id ?? option.key ?? option.COD_ID ?? option.USER ?? option.label;

    if (normalizedValue === undefined || normalizedValue === null) {
      return null;
    }

    const normalizedLabel = option.label ?? option.name ?? option.NOMBRE ?? normalizedValue;

    return {
      value: String(normalizedValue),
      label: String(normalizedLabel)
    };
  }

  return {
    value: String(option),
    label: String(option)
  };
}

function OrderCustomSelect({ options = [], value = "", onChange, placeholder = "-- Seleccionar --" }) {
  const normalizedOptions = options
    .map(normalizeOption)
    .filter(Boolean);

  const handleChange = (event) => {
    if (typeof onChange === "function") {
      onChange(event.target.value);
    }
  };

  return (
    <div className="custom-select-wrapper">
      <select className="custom-select" value={value ?? ""} onChange={handleChange}>
        <option value="" disabled>
          {placeholder}
        </option>
        {normalizedOptions.map((option) => (
          <option key={`${option.value}-${option.label}`} value={option.value}>
            {option.label}
          </option>
        ))}
      </select>
    </div>
  );
}

export default OrderCustomSelect;
